import { Component, ViewChild } from '@angular/core'
import { FieldType } from '@ngx-formly/core'
import { ColorPicker } from 'primeng/colorpicker'
import { InputMask } from 'primeng/inputmask'
import { distinctUntilChanged } from 'rxjs'

@Component({
  selector: 'basin-formly-color-picker',
  templateUrl: './formly-color-picker.component.html',
  styleUrls: ['./formly-color-picker.component.scss'],
})
export class FormlyColorPickerComponent extends FieldType {
  @ViewChild(ColorPicker) colorPicker!: ColorPicker
  @ViewChild(InputMask) inputMask!: InputMask

  ngAfterViewInit(): void {
    this.formControl.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((value) => {
        if (this.colorPicker && this.colorPicker.value !== value) {
          this.colorPicker.writeValue(value)
        }

        if (this.inputMask && this.inputMask.value !== value) {
          this.inputMask.writeValue(value)
        }
      })
  }
}
